import * as React from 'react';

import { useFormikContext } from 'formik';
import useBoolean from 'v2/hooks/useBoolean';

import { DataDisplay } from './DataDisplay';
import type { NewBankAccount } from '../form';
import { Layout } from '../Layout';
import { Modal } from '../Modal';

function Resume() {
  const [isModalOpen, setModalState] = useBoolean(false);
  const [fieldPreview, setFieldPreview] = React.useState('');
  const { values } = useFormikContext<NewBankAccount>();

  function handlePreviewClick(fieldName: string) {
    setFieldPreview(fieldName);
    setModalState.toTrue();
  }

  const selectedAsset = values[fieldPreview as keyof NewBankAccount] as File | null;
  const assetSource = React.useMemo(() => selectedAsset && URL.createObjectURL(selectedAsset), [selectedAsset]);

  return (
    <Layout
      title='É hora da revisão!'
      description='Quase lá! Confira seus dados com atenção antes de enviar para validação'
    >
      <DataDisplay values={values} onPreviewClick={fieldName => handlePreviewClick(fieldName)} />
      <Modal isOpen={isModalOpen} handleClose={setModalState.toFalse}>
        {selectedAsset?.type.includes('video') && (
          <video src={assetSource} autoPlay controls data-testid='selfie-video'>
            Seu navegador não suporta esta prévia. Porém, seu arquivo foi adicionado com sucesso.
          </video>
        )}
        {selectedAsset?.type.includes('image') && <img src={assetSource} alt='Prévia do upload realizado' />}
        {selectedAsset?.type.includes('pdf') && (
          <iframe src={assetSource} style={{ maxWidth: '100%' }} width='700' height='393' frameBorder='0' />
        )}
      </Modal>
    </Layout>
  );
}

export { Resume };
